/* Recherche Coiffissimo : catalogue /collections/all?view=cc-search, nuances, synonymes, filtres */
(function () {
  var INDEX_URL = '/collections/all?view=cc-search';
  var CACHE_KEY = 'ccs-idx-v12', CACHE_MS = 20 * 60 * 1000, RECENT_KEY = 'ccs-recent';
  var STOP = { de: 1, du: 1, des: 1, la: 1, le: 1, les: 1, l: 1, d: 1, pour: 1, en: 1, et: 1, a: 1, au: 1, aux: 1, un: 1, une: 1, avec: 1, sur: 1 };
  var GAMMES = ['color', 'zero', 'light', 'gloss'];
  var DEFAULT_FACETS = [{ k: 'rubrique', l: 'Rubrique' }, { k: 'marque', l: 'Marque' }, { k: 'main', l: 'Main' }, { k: 'format', l: 'Taille / format' }, { k: 'contenance', l: 'Contenance' }, { k: 'matiere', l: 'Matière' }, { k: 'prix', l: 'Prix' }, { k: 'dispo', l: 'Disponibilité' }];
  var PRICE_BUCKETS = [[0, 1000, 'Moins de 10 €'], [1000, 2000, '10 à 20 €'], [2000, 5000, '20 à 50 €'], [5000, 15000, '50 à 150 €'], [15000, 1e12, 'Plus de 150 €']];
  var desk = window.matchMedia('(min-width: 990px)');
  var DB = null, loading = null;

  /* ---------- outils ---------- */
  function T() { try { (window.__ccq = window.__ccq || []).push([].slice.call(arguments)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/œ/g, 'oe').replace(/æ/g, 'ae')
      .replace(/(\d)\s*[,\/_-]\s*(\d)/g, '$1.$2').replace(/[^a-z0-9.]+/g, ' ').replace(/(^|\s)\.+|\.+(\s|$)/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function stem(w) {
    if (/\d/.test(w) || w.length < 4) return w;
    if (w.length > 4 && /[sx]$/.test(w)) w = w.slice(0, -1);
    if (w.length > 4 && /ee$/.test(w)) w = w.slice(0, -1);
    return w;
  }
  function toks(s) { return norm(s).split(' ').filter(function (w) { return w && !STOP[w]; }).map(stem); }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' € HT'; }
  function img(u, w) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u.replace(/([?&])width=\d+/, '$1width=' + w); }
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], pp = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var cur = [i], best = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], pp[j - 2] + 1);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      pp = prev; prev = cur;
    }
    return prev[b.length];
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function recent() { return store(RECENT_KEY) || []; }
  function remember(q) { q = String(q || '').trim(); if (q.length < 2) return; var r = recent().filter(function (x) { return x !== q; }); r.unshift(q); store(RECENT_KEY, r.slice(0, 5)); }

  /* ---------- catalogue ---------- */
  function load() {
    if (DB) return Promise.resolve(DB);
    if (loading) return loading;
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < CACHE_MS) { DB = build(cached.d); return Promise.resolve(DB); }
    loading = fetch(INDEX_URL, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      DB = build(d); return DB;
    });
    return loading;
  }

  function build(d) {
    var syn = {}, multi = [];
    Object.keys(d.syn || {}).forEach(function (k) { var nk = norm(k); syn[nk] = toks(d.syn[k]); if (nk.indexOf(' ') > 0) multi.push(nk); });
    multi.sort(function (a, b) { return b.length - a.length; });
    var cats = {};
    // Les blocs « Pour vos … » et « Le matériel qui va avec » mettent en avant des produits d'autres rubriques :
    // ils ne comptent que si le produit n'est rangé nulle part ailleurs dans le menu.
    var companion = function (m) { return /^pour vos |^le materiel qui va avec/.test(norm(m[2]) + ' '); };
    var menu = d.menu || [], home = {};
    menu.forEach(function (m) { if (!companion(m)) home[m[0]] = 1; });
    menu.forEach(function (m) {
      if (home[m[0]] && companion(m)) return;
      (cats[m[0]] = cats[m[0]] || { top: [], sec: [] }); if (cats[m[0]].top.indexOf(m[1]) < 0) cats[m[0]].top.push(m[1]); if (cats[m[0]].sec.indexOf(m[2]) < 0) cats[m[0]].sec.push(m[2]);
    });
    var shades = [], products = [];
    d.p.forEach(function (p) {
      var c = cats[p.id] || { top: [], sec: [] };
      var f = {}; Object.keys(p.f || {}).forEach(function (k) { f[k] = p.f[k] || []; });
      // Le matériel reste dans Matériel, même s'il est aussi proposé sous Coloration, Patines…
      f.rubrique = c.top.indexOf('Matériel') >= 0 ? ['Matériel'] : c.top;
      f.prix = PRICE_BUCKETS.filter(function (b) { return p.p >= b[0] && p.p < b[1]; }).map(function (b) { return b[2]; });
      f.dispo = [p.av ? 'En stock' : 'Épuisé'].concat(p.b === 'Promo' ? ['En promo'] : []);
      var facetWords = [].concat(f.marque || [], f.main || [], f.format || [], f.contenance || [], f.matiere || []).join(' ');
      var gamme = String(p.n).replace(/^coiffissimo\s+/i, '');
      var P = {
        raw: p, id: p.id, url: p.u, name: p.n, desc: p.d, img: p.i, price: p.p, from: p.pv, av: p.av, badge: p.b, sales: p.s || 0, f: f,
        nuancier: /nuancier/.test(p.h), hasShades: false,
        fields: [[6, toks(p.n)], [3, toks(p.d)], [3, toks(p.t)], [2, toks(facetWords)], [1, toks((p.vt || []).join(' '))]],
        catToks: toks(c.top.join(' ') + ' ' + c.sec.join(' ')),
        xToks: toks(p.x || ''),
        skus: (p.sku || []).map(function (s) { return norm(s); }).filter(Boolean)
      };
      var seen = {};
      (p.sh || []).forEach(function (v) {
        var m = String(v.t).match(/^\s*(\d{1,2}(?:\.\d{1,2})?)\s*-?\s*(.*)$/);
        var code = v.n || (m && m[1]);
        if (!code) return;
        var name = (m ? m[2] : v.t).replace(/\s*-\s*rupture de stock\s*$/i, '').replace(/^-\s*/, '').trim();
        if (seen[code] && (seen[code].av || !v.av)) return;
        var S = { p: P, id: v.id, code: code, name: name, gamme: gamme, gk: norm(gamme), img: v.i, price: v.p, av: v.av, sku: norm(v.sku),
          sub: String(p.d || '').replace(/ - /g, ' · '), toks: toks(name) };
        if (seen[code]) shades[shades.indexOf(seen[code])] = S; else shades.push(S);
        seen[code] = S; P.hasShades = true;
      });
      products.push(P);
    });
    // Mots de description présents dans peu de produits : assez parlants pour compter comme une vraie correspondance.
    var df = {};
    products.forEach(function (P) { var u = {}; P.xToks.forEach(function (t) { if (!u[t]) { u[t] = 1; df[t] = (df[t] || 0) + 1; } }); });
    products.forEach(function (P) { P.rareToks = P.xToks.filter(function (t) { return df[t] <= 5; }); });
    var articles = (d.a || []).map(function (a) { return { title: a[0], url: a[1], blog: a[2], toks: toks(a[0]) }; });
    var CATS = { coloration: 'Coloration', decoloration: 'Décoloration', patine: 'Patines', 'gestion-du-salon': 'Gestion du salon' };
    var formations = (d.f || []).map(function (f) {
      var cat = CATS[f[4]] || String(f[4] || '').replace(/-/g, ' ').replace(/^./, function (c) { return c.toUpperCase(); });
      return { title: f[0], url: f[1], img: f[2], dur: f[3], cat: cat, toks: toks(f[0] + ' ' + f[5] + ' ' + cat), ttoks: toks(f[0]) };
    });
    var tops = [];
    (d.menu || []).forEach(function (m) { if (tops.indexOf(m[1]) < 0) tops.push(m[1]); });
    return { products: products, shades: shades, articles: articles, formations: formations, syn: syn, multi: multi, facets: d.fac || DEFAULT_FACETS, tops: tops };
  }

  /* ---------- moteur ---------- */
  // Même mot à une faute près (« rinczge » = « rincage »), première lettre juste.
  function near(a, b) {
    if (a === b) return true;
    var max = b.length >= 8 ? 2 : b.length >= 4 ? 1 : 0;
    return max > 0 && a[0] === b[0] && lev(a, b, max) <= max;
  }
  function parse(q) {
    var groups = [], ws = norm(q).split(' ');
    // Synonymes de plusieurs mots, tolérants aux fautes.
    DB.multi.forEach(function (k) {
      var kw = k.split(' ');
      for (var i = 0; i + kw.length <= ws.length; i++) {
        if (kw.every(function (w, j) { return near(ws[i + j], w); })) { groups.push({ raw: k, alts: [toks(k), DB.syn[k]] }); ws.splice(i, kw.length); return; }
      }
    });
    for (var i = 0; i < ws.length - 1; i++) {
      if (/^\d{1,2}$/.test(ws[i]) && /^\d{1,2}$/.test(ws[i + 1]) && +ws[i] <= 12) { ws[i] = ws[i] + '.' + ws[i + 1]; ws.splice(i + 1, 1); }
    }
    ws.forEach(function (w) {
      if (!w || STOP[w]) return;
      if (/^\d+(\.\d+)?$/.test(w)) return groups.push({ raw: w, num: true });
      var sy = DB.syn[w] || DB.syn[stem(w)];
      if (!sy && w.length >= 5) { var sk = Object.keys(DB.syn).filter(function (k) { return k.indexOf(' ') < 0 && near(w, k); })[0]; if (sk) sy = DB.syn[sk]; }
      groups.push({ raw: w, alts: sy ? [[stem(w)], sy] : [[stem(w)]] });
    });
    return groups;
  }
  function tokScore(q, t) {
    if (t === q) return 1;
    if (q.length >= 2 && t.indexOf(q) === 0) return 0.85;
    var max = q.length >= 8 ? 2 : q.length >= 5 ? 1 : 0;
    // Faute tolérée seulement si la première lettre est juste (« decoloration » ne doit pas devenir « coloration »).
    if (max && q[0] === t[0] && lev(q, t.length > q.length + 2 ? t.slice(0, q.length + 1) : t, max) <= max) return 0.55;
    return 0;
  }
  // Descriptions : mot entier seulement (« color » ne doit pas trouver « colorés »).
  function exactScore(g, list) {
    return g.alts.some(function (phrase) { return phrase.every(function (w) { return list.indexOf(w) >= 0; }); }) ? 1 : 0;
  }
  // Chaque alternative est une expression : tous ses mots doivent se trouver dans la même liste.
  function groupScore(g, list) {
    var best = 0;
    g.alts.forEach(function (phrase, i) {
      var sc = 1;
      for (var w = 0; w < phrase.length && sc; w++) {
        var bw = 0;
        for (var k = 0; k < list.length; k++) { var t = tokScore(phrase[w], list[k]); if (t > bw) bw = t; if (bw >= 1) break; }
        sc = Math.min(sc, bw);
      }
      sc *= i === 0 ? 1 : 0.9;
      if (sc > best) best = sc;
    });
    return best;
  }
  // Renvoie [score, correspond seulement par la rubrique du menu]
  function productScore(P, words) {
    var total = 0, viaCat = false;
    for (var i = 0; i < words.length; i++) {
      var g = words[i], best = 0;
      P.fields.forEach(function (fw) { var s = groupScore(g, fw[1]) * fw[0]; if (s > best) best = s; });
      if (!best) best = exactScore(g, P.rareToks) * 0.5;
      if (!best) { best = Math.max(groupScore(g, P.catToks), exactScore(g, P.xToks)) * 1.5; if (!best) return [0, false]; viaCat = true; }
      total += best;
    }
    return [total + Math.log(1 + P.sales) * 0.6, viaCat];
  }
  function skuHit(skus, raw) {
    raw = norm(raw).replace(/\s/g, '');
    var partial = raw.length >= 5 && /\d/.test(raw);
    return raw.length >= 3 && skus.some(function (s) { return s === raw || (partial && s.indexOf(raw) === 0); });
  }

  function gammeOf(raw) {
    var w = norm(raw);
    if (w.length < 3 || /\d/.test(w)) return '';
    for (var i = 0; i < GAMMES.length; i++) {
      var g = GAMMES[i];
      if (w === g || g.indexOf(w) === 0 || (w.length >= 4 && lev(w, g, 1) <= 1)) return g;
    }
    return '';
  }
  function matchesAnything(g) {
    var i;
    for (i = 0; i < DB.products.length; i++) {
      var P = DB.products[i];
      if (groupScore(g, P.catToks) || exactScore(g, P.xToks) || P.fields.some(function (f) { return groupScore(g, f[1]); })) return true;
    }
    for (i = 0; i < DB.shades.length; i++) if (groupScore(g, DB.shades[i].toks)) return true;
    for (i = 0; i < DB.articles.length; i++) if (groupScore(g, DB.articles[i].toks)) return true;
    return skuHit(DB.products.reduce(function (a, P) { return a.concat(P.skus); }, []), g.raw);
  }
  function codeMatch(code, q) {
    if (q.indexOf('.') < 0) return parseInt(code, 10) === +q && code.split('.')[0] === q;
    return code === q || code.indexOf(q) === 0;
  }
  function codeCandidates(c) {
    var out = [c];
    if (/^\d{2,4}$/.test(c)) { out.push(c[0] + '.' + c.slice(1)); if (c.length >= 3) out.push(c.slice(0, 2) + '.' + c.slice(2)); }
    return out;
  }

  // Repigmentant (masque, shampoing…) : Color Mask en tête des résultats, et la recherche validée ouvre sa page.
  var CM_URL = '/pages/colormask-soin-masque-pigmentant-cheveux';
  // Dès « repi » en cours de frappe.
  function repig(w) { return (w.length >= 4 && ('repigmentant'.indexOf(w) === 0 || 'repigmentation'.indexOf(w) === 0)) || /^repigm|^pigmentant/.test(w) || (w[0] === 'r' && w.length >= 8 && lev(w.slice(0, 12), 'repigmentant', 2) <= 2); }
  function cmIntent(q) { var n = norm(q).replace(/(^| )re (?=pigm)/g, '$1re'); return /colou?r ?mask/.test(n) || n.split(' ').some(repig); }
  function search(q) {
    if (!cmIntent(q)) return baseSearch(q);
    // Les autres mots (« shampoing », « masque »…) gardent leurs résultats habituels sous Color Mask.
    var rest = norm(q).replace(/(^| )re (?=pigm)/g, '$1re').replace(/colou?r ?mask/g, ' ').split(' ').filter(function (w) { return w && !repig(w); }).join(' ');
    var res = baseSearch(rest || q);
    res.q = q;
    var cm = DB.products.filter(function (P) { return P.raw.h === 'color-mask'; })[0];
    if (!cm) return res;
    res.products = [cm].concat(res.products.filter(function (P) { return P !== cm; }));
    res.ignored = (res.ignored || []).filter(function (w) { return !repig(norm(w)); });
    res.partial = false;
    res.total = res.shades.length + res.products.length + res.articles.length + res.formations.length;
    return res;
  }

  function baseSearch(q) {
    var groups = parse(q), nums = groups.filter(function (g) { return g.num; }), words = groups.filter(function (g) { return !g.num; });
    var res = { q: q, shades: [], near: [], products: [], articles: [], formations: [], total: 0 };
    if (!groups.length) return res;

    // Nuances
    words.forEach(function (g) { g.gamme = gammeOf(g.raw); });
    var gammeWords = words.filter(function (g) { return g.gamme; });
    // Un mot qui ne correspond à rien dans tout le catalogue est ignoré au lieu de vider les résultats.
    res.ignored = [];
    words = words.filter(function (g) { if (g.gamme || matchesAnything(g)) return true; res.ignored.push(g.raw); return false; });
    var nameWords = words.filter(function (g) { return !g.gamme; });
    if (!nums.length && !words.length) return res;
    // Numéro de nuance : « 7 » = toute la hauteur 7, « 7.4 » = 7.4, 7.43, 7.44…, « 73 » = 7.3 si aucune hauteur 73.
    var codes = null, exactCode = '';
    if (nums.length === 1) {
      var cand = codeCandidates(nums[0].raw);
      for (var ci = 0; ci < cand.length && !codes; ci++) {
        var c = cand[ci], hit = DB.shades.filter(function (s) { return codeMatch(s.code, c); });
        if (hit.length) { codes = c; exactCode = hit.some(function (s) { return s.code === c; }) ? c : ''; }
      }
      if (!codes) codes = '#';
    }
    var shadeOk = nums.length <= 1 && (codes === null ? nameWords.length > 0 : true);
    if (shadeOk) {
      res.shades = DB.shades.filter(function (s) {
        if (codes && !codeMatch(s.code, codes)) return false;
        if (gammeWords.length && !gammeWords.some(function (g) { return s.gk === g.gamme; })) return false;
        return nameWords.every(function (g) { return groupScore(g, s.toks) > 0; });
      });
      var gOrder = function (s) { var i = GAMMES.indexOf(s.gk); return i < 0 ? 9 : i; };
      // Tri par numéro (pigments et patines 0.x en dernier), gammes côte à côte ; le numéro exact d'abord.
      var hOf = function (c) { var h = parseInt(c, 10); return h === 0 ? 99 : h; }, rOf = function (c) { return c.split('.')[1] || ''; };
      res.shades.sort(function (a, b) { return ((b.code === exactCode) - (a.code === exactCode)) || (b.av - a.av) || hOf(a.code) - hOf(b.code) || rOf(a.code).localeCompare(rOf(b.code)) || gOrder(a) - gOrder(b); });
    }
    if (res.shades.length && exactCode && res.shades.length <= 4) {
      var base = res.shades[0], h = parseInt(base.code, 10), rf = (base.code.split('.')[1] || '');
      if (rf) {
        res.near = DB.shades.filter(function (s) {
          if (s.p !== base.p || s.code === base.code || !s.av || res.shades.indexOf(s) >= 0) return false;
          var sh = parseInt(s.code, 10), sr = s.code.split('.')[1] || '';
          return (sr === rf && Math.abs(sh - h) === 1) || (sh === h && sr.length && sr !== rf && sr.indexOf(rf) >= 0);
        }).slice(0, 4);
      }
    }

    // Références exactes
    var skuProducts = DB.products.filter(function (P) { return skuHit(P.skus, q); });

    // Produits
    var scored = [];
    var pWords = words.map(function (g) { return g.gamme ? { raw: g.raw, alts: [[g.gamme]] } : g; });
    // Un nombre qui n'est pas une nuance (« ciseaux 5.5 ») se cherche dans le texte des produits.
    if (!res.shades.length && nameWords.length) nums.forEach(function (g) { pWords.push({ raw: g.raw, alts: [[norm(g.raw)]] }); });
    if (pWords.length) {
      var direct = [], viaCat = [];
      DB.products.forEach(function (P) { var r = productScore(P, pWords); if (r[0]) (r[1] ? viaCat : direct).push([P, r[0]]); });
      scored = direct.length ? direct : viaCat;
      // Aucun produit ne contient tous les mots : on garde ceux qui en contiennent le plus.
      if (!scored.length && pWords.length > 1 && !res.shades.length) {
        var best = 0, part = [];
        DB.products.forEach(function (P) {
          var n = 0, sc = 0;
          pWords.forEach(function (g) { var b = 0; P.fields.forEach(function (f) { var x = groupScore(g, f[1]) * f[0]; if (x > b) b = x; }); if (b) { n++; sc += b; } });
          if (n) part.push([P, n, sc + Math.log(1 + P.sales) * 0.6]);
          if (n > best) best = n;
        });
        scored = part.filter(function (x) { return x[1] === best; }).map(function (x) { return [x[0], x[2]]; });
        res.partial = scored.length > 0;
      }
    }
    var owners = [];
    res.shades.forEach(function (s) { if (owners.indexOf(s.p) < 0) owners.push(s.p); });
    if (nums.length && !nameWords.length) {
      scored = owners.map(function (P) { return [P, 10]; });
      if (res.shades.length) DB.products.forEach(function (P) { if (P.nuancier) scored.push([P, 5]); });
    } else if (res.shades.length) {
      owners.forEach(function (P) { if (!scored.some(function (x) { return x[0] === P; })) scored.push([P, 4]); });
    }
    skuProducts.forEach(function (P) { if (!scored.some(function (x) { return x[0] === P; })) scored.push([P, 50]); else scored.forEach(function (x) { if (x[0] === P) x[1] += 50; }); });
    scored.sort(function (a, b) { return (b[1] - a[1]) || (b[0].av - a[0].av) || (b[0].sales - a[0].sales); });
    res.products = scored.map(function (x) { return x[0]; });
    if (skuProducts.length && res.shades.length === 0) {
      DB.shades.forEach(function (s) { if (s.sku && s.sku === norm(q).replace(/\s/g, '')) res.shades.push(s); });
    }

    // Articles
    // Articles et formations : le mot tapé seulement, sans ses synonymes (sinon « balayage » ramènerait toute la décoloration).
    var aw = words.map(function (g) { return { raw: g.raw, alts: g.gamme ? [[stem(g.raw)], [g.gamme]] : [g.alts[0]] }; });
    if (!aw.length && res.shades.length && exactCode) aw = toks(res.shades[0].name).slice(-1).map(function (t) { return { raw: t, alts: [[t]] }; });
    if (aw.length) {
      res.articles = DB.articles.filter(function (a) { return aw.every(function (g) { return groupScore(g, a.toks) >= 0.85; }); });
    }
    if (aw.length) {
      res.formations = DB.formations.map(function (f) {
        var sc = 0;
        for (var i = 0; i < aw.length; i++) { var t = Math.max(groupScore(aw[i], f.ttoks) * 2, groupScore(aw[i], f.toks)); if (!t) return null; sc += t; }
        return [f, sc];
      }).filter(Boolean).sort(function (a, b) { return b[1] - a[1]; }).map(function (x) { return x[0]; });
    }
    res.total = res.shades.length + res.products.length + res.articles.length + res.formations.length;
    return res;
  }

  /* ---------- rendu commun ---------- */
  var ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var X = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
  var CLOCK = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8" fill="none"/><path d="M12 8v4l3 2" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linecap="round"/></svg>';
  function thumb(s, size) {
    return '<span class="ccs-thumb" style="width:' + size + 'px;height:' + size + 'px">' +
      (s.p.img ? '<img src="' + esc(img(s.p.img, size * 2)) + '" alt="" loading="lazy">' : '') +
      (s.img ? '<img class="ccs-swatch" src="' + esc(img(s.img, 120)) + '" alt="" loading="lazy">' : '') + '</span>';
  }
  function shadeRow(s, cls) {
    return '<a class="ccs-shade ' + (cls || '') + '" href="' + esc(s.p.url) + '" data-ccs-link>' + thumb(s, 60) +
      '<span class="ccs-txt"><span class="ccs-name"><b>' + esc(s.gamme) + ' ' + esc(s.code) + '</b> ' + esc(s.name) + '</span><span class="ccs-sub">' + esc(s.sub) + '</span></span>' +
      '<span class="ccs-meta"><span class="ccs-price">' + money(s.price) + '</span>' + (s.av ? '<span class="ccs-ref">Réf. ' + esc(s.sku.toUpperCase()) + '</span>' : '<span class="ccs-out">Épuisée</span>') + '</span></a>';
  }
  function nearChip(s) {
    return '<a class="ccs-chip" href="' + esc(s.p.url) + '" data-ccs-link>' + (s.img ? '<img src="' + esc(img(s.img, 60)) + '" alt="">' : '') + '<span><b>' + esc(s.gamme) + '</b> ' + esc(s.code) + ' ' + esc(s.name) + '</span></a>';
  }
  function productRow(P) {
    return '<a class="ccs-prow" href="' + esc(P.url) + '" data-ccs-link>' +
      '<span class="ccs-pimg">' + (P.img ? '<img src="' + esc(img(P.img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="ccs-txt"><span class="ccs-name"><b>' + esc(P.name) + '</b></span><span class="ccs-sub">' + esc([P.desc, (P.from ? 'dès ' : '') + money(P.price)].filter(Boolean).join(' · ')) + (P.av ? '' : ' · <span class="ccs-out">' + (P.raw.soon ? 'Bientôt disponible' : 'Épuisé') + '</span>') + '</span></span></a>';
  }
  function productCard(P) {
    return '<a class="ccs-card" href="' + esc(P.url) + '" data-ccs-link><span class="ccs-cimg">' + (P.img ? '<img src="' + esc(img(P.img, 400)) + '" alt="" loading="lazy">' : '') +
      (P.badge ? '<span class="ccs-badge">' + esc(P.badge) + '</span>' : '') + (P.av ? '' : '<span class="ccs-badge ccs-badge--out">' + (P.raw.soon ? 'Bientôt disponible' : 'Épuisé') + '</span>') + '</span>' +
      '<span class="ccs-cname">' + esc(P.name) + '</span>' + (P.desc ? '<span class="ccs-cdesc">' + esc(P.desc) + '</span>' : '') +
      '<span class="ccs-cprice">' + (P.from ? 'dès ' : '') + money(P.price) + '</span></a>';
  }
  var PLAY = '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
  function dur(s) { s = +s || 0; if (!s) return ''; var m = Math.floor(s / 60), r = s % 60; return m ? m + ' min' + (r ? ' ' + (r < 10 ? '0' : '') + r : '') : r + ' s'; }
  function articleLink(a) { return '<a class="ccs-art" href="' + esc(a.url) + '" data-ccs-link><span class="ccs-atitle">' + esc(a.title) + '</span><span class="ccs-sub">' + esc(a.blog) + '</span></a>'; }
  function articleCard(a) {
    return '<a class="ccs-acard" href="' + esc(a.url) + '" data-ccs-link><span class="ccs-akicker">' + esc(a.blog) + '</span><span class="ccs-actitle">' + esc(a.title) + '</span><span class="ccs-aread">Lire l\'article' + ARROW + '</span></a>';
  }
  function formationRow(f) {
    return '<a class="ccs-frow" href="' + esc(f.url) + '" data-ccs-link><span class="ccs-fthumb">' + (f.img ? '<img src="' + esc(f.img) + '" alt="" loading="lazy">' : '') + '<span class="ccs-play">' + PLAY + '</span></span>' +
      '<span class="ccs-txt"><span class="ccs-atitle">' + esc(f.title) + '</span><span class="ccs-sub">Formation · ' + esc(dur(f.dur)) + '</span></span></a>';
  }
  function formationCard(f) {
    return '<a class="ccs-fcard" href="' + esc(f.url) + '" data-ccs-link><span class="ccs-fcimg">' + (f.img ? '<img src="' + esc(f.img) + '" alt="" loading="lazy">' : '') +
      '<span class="ccs-play ccs-play--l">' + PLAY + '</span>' + (f.dur ? '<span class="ccs-dur">' + esc(dur(f.dur)) + '</span>' : '') + '</span>' +
      '<span class="ccs-akicker">' + esc(f.cat) + '</span><span class="ccs-actitle">' + esc(f.title) + '</span></a>';
  }
  function resultsUrl(q) { return '/search?q=' + encodeURIComponent(String(q || '').trim()); }
  // Nos champs s'appellent cc_q pour que l'app Rapid Search (script injecté par Shopify) ne s'y accroche pas.
  function goSearch(e, input) { e.preventDefault(); var q = input.value.trim(); if (!q) return; remember(q); if (cmIntent(q)) { T('recherche', 'valider', q, { redirection: 'color-mask' }); location.href = CM_URL; return; } T('recherche', 'valider', q); location.href = resultsUrl(q); }

  /* ---------- panneau instantané (ordinateur) et écran mobile ---------- */
  var root = document.querySelector('[data-ccm]');
  var panel = document.querySelector('[data-ccs-panel]');
  var mob = document.querySelector('[data-ccs-mobile]');
  var mobInput = mob && mob.querySelector('input[name="cc_q"]');
  var mobBody = mob && mob.querySelector('[data-ccs-mbody]');
  var deskInput = root && root.querySelector('.ccm-bar .ccm-search input[name="cc_q"]');
  var active = -1, lastRes = null, timer, instG = '';
  function gammePills(r) {
    var g = {}; r.shades.forEach(function (s) { g[s.gk] = g[s.gk] || { l: s.gamme, n: 0 }; g[s.gk].n++; });
    var keys = Object.keys(g);
    if (keys.length < 2) return '';
    return '<div class="ccs-pills ccs-pills--i"><button type="button" data-ccs-ig=""' + (instG ? '' : ' class="is-on"') + '>Toutes <span>' + r.shades.length + '</span></button>' +
      keys.map(function (k) { return '<button type="button" data-ccs-ig="' + esc(k) + '"' + (instG === k ? ' class="is-on"' : '') + '>' + esc(g[k].l) + ' <span>' + g[k].n + '</span></button>'; }).join('') + '</div>';
  }
  function shownShades(r) { return instG ? r.shades.filter(function (s) { return s.gk === instG; }) : r.shades; }

  function instantHTML(r, mobile) {
    if (!r.q.trim()) return mobile ? emptyMobile() : emptyDesk();
    if (r.ignored && r.ignored.length && r.total) r.note = 'Mot ignoré : ' + r.ignored.join(', ');
    if (!r.total) {
      return '<div class="ccs-none"><b>Aucun résultat pour « ' + esc(r.q) + ' »</b><span>Essayez un numéro de nuance (7.3), une référence (TCOI73) ou un mot plus court.</span>' +
        '<a href="tel:+33189701036">Besoin d\'aide ? 01 89 70 10 36</a></div>';
    }
    var h = '';
    if (mobile) {
      if (r.shades.length) h += '<div class="ccs-label">Nuances</div>' + gammePills(r) + shownShades(r).slice(0, 12).map(function (s) { return shadeRow(s); }).join('');
      if (r.products.length) h += '<div class="ccs-label">Produits</div>' + r.products.slice(0, 6).map(productRow).join('');
      if (r.formations.length) h += '<div class="ccs-label">Formations</div>' + r.formations.slice(0, 3).map(formationRow).join('');
      if (r.articles.length) h += '<div class="ccs-label">Conseils</div>' + r.articles.slice(0, 3).map(articleLink).join('');
      return '<div class="ccs-mres">' + h + '</div><a class="ccs-mall" href="' + esc(resultsUrl(r.q)) + '" data-ccs-all>Voir les ' + r.total + ' résultats' + ARROW + '</a>';
    }
    var left = '', right = '';
    if (r.shades.length) {
      var ss = shownShades(r);
      left = '<div class="ccs-head"><span class="ccs-h">Nuances</span><span class="ccs-count">' + r.shades.length + ' résultat' + (r.shades.length > 1 ? 's' : '') + '</span></div>' + gammePills(r) +
        ss.slice(0, 12).map(function (s) { return shadeRow(s); }).join('') +
        (ss.length > 12 ? '<a class="ccs-moreshades" href="' + esc(resultsUrl(r.q)) + '" data-ccs-all>Voir les ' + ss.length + ' nuances' + ARROW + '</a>' : '') +
        (r.near.length ? '<div class="ccs-near"><span class="ccs-label">Nuances proches</span><div class="ccs-chips">' + r.near.map(nearChip).join('') + '</div></div>' : '');
      if (r.products.length) right += '<span class="ccs-label">Produits</span>' + r.products.slice(0, 3).map(productRow).join('');
    } else {
      left = '<div class="ccs-head"><span class="ccs-h">Produits</span><span class="ccs-count">' + r.products.length + ' résultat' + (r.products.length > 1 ? 's' : '') + '</span></div>' + r.products.slice(0, 6).map(productRow).join('');
    }
    if (r.formations.length) right += '<span class="ccs-label' + (right ? ' ccs-gap' : '') + '">Formations</span>' + r.formations.slice(0, 2).map(formationRow).join('');
    if (r.articles.length) right += '<span class="ccs-label' + (right ? ' ccs-gap' : '') + '">Conseils</span>' + r.articles.slice(0, r.formations.length ? 2 : 3).map(articleLink).join('');
    return (r.note ? '<div class="ccs-note">' + esc(r.note) + '</div>' : '') + '<div class="ccs-cols"><div class="ccs-left">' + left + '</div>' + (right ? '<div class="ccs-right">' + right + '</div>' : '') + '</div>' +
      '<div class="ccs-foot"><a href="' + esc(resultsUrl(r.q)) + '" data-ccs-all>Voir les ' + r.total + ' résultats pour « ' + esc(r.q) + ' »' + ARROW + '</a>' +
      '<span class="ccs-keys"><span><kbd>↑↓</kbd>naviguer</span><span><kbd>Entrée</kbd>ouvrir</span><span><kbd>Échap</kbd>fermer</span></span></div>';
  }
  function recentHTML() {
    var r = recent();
    return r.length ? '<div class="ccs-label">Vos dernières recherches</div>' + r.map(function (q) {
      return '<a class="ccs-recent" href="' + esc(resultsUrl(q)) + '" data-ccs-q="' + esc(q) + '">' + CLOCK + '<span>' + esc(q) + '</span></a>';
    }).join('') : '';
  }
  var TIPS = ['7.3', 'TCOI73', 'cuivré', '20 volumes', 'sans ammoniaque'];
  function tipsHTML() { return '<div class="ccs-label">Cherchez par nuance, référence ou reflet</div><div class="ccs-tips">' + TIPS.map(function (t) { return '<button type="button" data-ccs-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') + '</div>'; }
  function emptyDesk() { return '<div class="ccs-cols"><div class="ccs-left">' + (recentHTML() || '') + tipsHTML() + '</div></div>'; }
  function emptyMobile() {
    var tiles = '';
    if (root) root.querySelectorAll('.ccm-li:not(.ccm-li--sec) > .ccm-tl').forEach(function (t) {
      var im = t.querySelector('.ccm-thumb img'), label = t.querySelector('.ccm-tl-t');
      if (!im || !label) return;
      tiles += '<button type="button" class="ccs-tile" data-ccs-menu="' + esc(t.getAttribute('aria-controls') || '') + '"><img src="' + esc(im.currentSrc || im.src) + '" alt=""><span>' + esc(label.childNodes[0].textContent.trim()) + '</span></button>';
    });
    return '<div class="ccs-mres">' + recentHTML() + tipsHTML() + (tiles ? '<div class="ccs-label">Accès rapide</div><div class="ccs-tiles">' + tiles + '</div>' : '') + '</div>';
  }

  function links(container) { return [].slice.call(container.querySelectorAll('[data-ccs-link], [data-ccs-all]')); }
  function setActive(i) {
    var l = links(panel); l.forEach(function (a) { a.classList.remove('is-active'); });
    active = Math.max(-1, Math.min(i, l.length - 1));
    if (active >= 0) { l[active].classList.add('is-active'); l[active].scrollIntoView({ block: 'nearest' }); }
  }
  function openPanel() { if (!panel) return; panel.hidden = false; document.documentElement.classList.add('ccs-on'); root && root.closest('.shopify-section') && root.closest('.shopify-section').classList.add('ccm-active'); }
  function closePanel() { if (!panel) return; panel.hidden = true; active = -1; document.documentElement.classList.remove('ccs-on'); var sec = root && root.closest('.shopify-section'); if (sec && !root.querySelector('.ccm-li.is-open')) sec.classList.remove('ccm-active'); }
  function renderDesk(q, keepG) {
    if (!keepG) instG = '';
    load().then(function () {
      lastRes = search(q);
      T('recherche', 'saisie', q, { resultats: lastRes.total, nuances: lastRes.shades.length, zone: 'ordinateur' });
      panel.querySelector('[data-ccs-pbody]').innerHTML = instantHTML(lastRes, false);
      active = -1; openPanel();
    });
  }
  function renderMob(q, keepG) {
    if (!keepG) instG = '';
    load().then(function () { lastRes = search(q); T('recherche', 'saisie', q, { resultats: lastRes.total, nuances: lastRes.shades.length, zone: 'mobile' }); mobBody.innerHTML = instantHTML(lastRes, true); });
  }

  if (deskInput && panel) {
    deskInput.addEventListener('focus', function () { if (desk.matches && panel.hidden) { load(); renderDesk(deskInput.value); } });
    deskInput.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { renderDesk(deskInput.value); }, 60); });
    deskInput.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { closePanel(); deskInput.blur(); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); remember(deskInput.value); links(panel)[active].click(); }
    });
    deskInput.form.addEventListener('submit', function (e) { goSearch(e, deskInput); });
    document.addEventListener('mousedown', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || deskInput.form.contains(e.target)) return;
      closePanel();
    });
    panel.addEventListener('click', function (e) {
      var ig = e.target.closest('[data-ccs-ig]');
      if (ig) { instG = ig.dataset.ccsIg; renderDesk(deskInput.value, true); deskInput.focus(); return; }
      var t = e.target.closest('[data-ccs-q]');
      if (t && t.tagName === 'BUTTON') { deskInput.value = t.dataset.ccsQ; deskInput.focus(); renderDesk(deskInput.value); return; }
      if (e.target.closest('[data-ccs-link], [data-ccs-all], [data-ccs-q]')) remember(deskInput.value);
    });
    desk.addEventListener('change', closePanel);
    // Le panneau ne se ferme pas au survol : seulement Échap, clic ailleurs ou clic sur une rubrique du menu.
    root.querySelectorAll('.ccm-tl').forEach(function (b) { b.addEventListener('click', closePanel); });
  }

  function openMobile(q) {
    if (!mob) return;
    mob.hidden = false; document.documentElement.classList.add('ccs-mopen');
    if (typeof q === 'string') mobInput.value = q;
    // Focus synchrone : iOS n'ouvre le clavier que dans le geste de l'utilisateur.
    mobInput.focus();
    renderMob(mobInput.value);
  }
  function closeMobile() { if (!mob) return; mob.hidden = true; document.documentElement.classList.remove('ccs-mopen'); }
  if (mob) {
    document.querySelectorAll('[data-ccs-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openMobile(''); }); });
    mob.querySelector('[data-ccs-close]').addEventListener('click', closeMobile);
    mobInput.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { renderMob(mobInput.value); }, 60); });
    mobInput.form.addEventListener('submit', function (e) { goSearch(e, mobInput); });
    mob.querySelector('[data-ccs-clear]').addEventListener('click', function () { mobInput.value = ''; renderMob(''); mobInput.focus(); });
    mob.addEventListener('click', function (e) {
      var ig = e.target.closest('[data-ccs-ig]');
      if (ig) { instG = ig.dataset.ccsIg; renderMob(mobInput.value, true); return; }
      var t = e.target.closest('[data-ccs-q]');
      if (t && t.tagName === 'BUTTON') { mobInput.value = t.dataset.ccsQ; renderMob(mobInput.value); return; }
      var m = e.target.closest('[data-ccs-menu]');
      if (m) {
        closeMobile();
        var btn = root && root.querySelector('.ccm-tl[aria-controls="' + m.dataset.ccsMenu + '"]');
        var burger = root && root.querySelector('[data-ccm-open]');
        if (burger) burger.click();
        if (btn) setTimeout(function () { btn.click(); }, 60);
        return;
      }
      if (e.target.closest('[data-ccs-link], [data-ccs-all], [data-ccs-q]')) remember(mobInput.value);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mob.hidden) closeMobile(); });
  }

  window.ccSearch = { load: load, search: function (q) { return search(q); } };

  /* ---------- page de résultats ---------- */
  var page = document.querySelector('[data-ccs-page]');
  if (page) initPage(page);

  function initPage(el) {
    var params = new URLSearchParams(location.search);
    var q = params.get('q') || params.get('cc_q') || '';
    var state = { sel: {}, gamme: '', sort: params.get('tri') || 'pertinence', limit: 24, allShades: false, more: false, sheet: false, noTop: '' };
    (params.get('f') || '').split('|').forEach(function (pair) {
      var i = pair.indexOf(':'); if (i < 1) return;
      var k = pair.slice(0, i), v = pair.slice(i + 1);
      (state.sel[k] = state.sel[k] || []).push(v);
    });
    if (params.get('gamme')) state.gamme = params.get('gamme');
    remember(q);
    if (cmIntent(q)) { location.replace(CM_URL); return; }
    el.innerHTML = '<div class="ccs-loading">Recherche en cours…</div>';
    load().then(function () { var r = search(q); T('recherche', 'page_resultats', q, { resultats: r.total, nuances: r.shades.length, zero: !r.total }); draw(r); });

    function syncUrl() {
      var p = new URLSearchParams(); p.set('q', q);
      var f = []; Object.keys(state.sel).forEach(function (k) { state.sel[k].forEach(function (v) { f.push(k + ':' + v); }); });
      if (f.length) p.set('f', f.join('|'));
      if (state.gamme) p.set('gamme', state.gamme);
      if (state.sort !== 'pertinence') p.set('tri', state.sort);
      history.replaceState(null, '', '/search?' + p.toString());
    }
    function values(P, k) { return P.f[k] || []; }
    function passes(P, except) {
      return Object.keys(state.sel).every(function (k) {
        if (k === except || !state.sel[k].length) return true;
        var v = values(P, k); return state.sel[k].some(function (x) { return v.indexOf(x) >= 0; });
      });
    }
    // Filtres et valeurs fixes (calculés sur tous les résultats) ; seuls les nombres suivent les autres filtres cochés.
    function facetData(list) {
      var out = [];
      DB.facets.forEach(function (fd) {
        var all = {};
        list.forEach(function (P) { values(P, fd.k).forEach(function (v) { all[v] = (all[v] || 0) + 1; }); });
        var vals = Object.keys(all);
        var sel = state.sel[fd.k] || [];
        if (!(vals.length >= 2 || (vals.length === 1 && all[vals[0]] < list.length) || sel.length)) return;
        var counts = {};
        list.filter(function (P) { return passes(P, fd.k); }).forEach(function (P) { values(P, fd.k).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
        if (fd.k === 'prix') vals.sort(function (a, b) { return PRICE_BUCKETS.findIndex(function (x) { return x[2] === a; }) - PRICE_BUCKETS.findIndex(function (x) { return x[2] === b; }); });
        else vals.sort(function (a, b) { return all[b] - all[a] || a.localeCompare(b, 'fr'); });
        out.push({ k: fd.k, l: fd.l, vals: vals, counts: counts, sel: sel });
      });
      return out;
    }
    function facetHTML(fd, mobile, first) {
      var open = mobile ? (fd.sel.length || first ? ' open' : '') : ' open';
      var shown = fd.vals.length > 7 && !fd.more ? fd.vals.slice(0, 6) : fd.vals;
      return '<details class="ccs-facet"' + open + '><summary>' + esc(fd.l) + (fd.sel.length ? ' <span class="ccs-fcount">' + fd.sel.length + '</span>' : '') + '</summary>' +
        shown.map(function (v) {
          var on = fd.sel.indexOf(v) >= 0, n = fd.counts[v] || 0, off = !n && !on;
          return '<label class="ccs-opt' + (off ? ' is-off' : '') + '"><input type="checkbox" data-ccs-f="' + esc(fd.k) + '" value="' + esc(v) + '"' + (on ? ' checked' : '') + (off ? ' disabled' : '') + '><span>' + esc(v) + '</span><span class="ccs-n">' + n + '</span></label>';
        }).join('') + (shown.length < fd.vals.length ? '<button type="button" class="ccs-more" data-ccs-fmore="' + esc(fd.k) + '">+ ' + (fd.vals.length - shown.length) + ' autres</button>' : '') + '</details>';
    }
    // Aucun résultat : on relance avec des suggestions, les meilleures ventes par rubrique et les promos du moment.
    function noResultHTML() {
      var sold = DB.products.filter(function (P) { return P.av && P.sales > 0; }).sort(function (a, b) { return b.sales - a.sales; });
      var tops = DB.tops.filter(function (t) { return sold.filter(function (P) { return P.f.rubrique.indexOf(t) >= 0; }).length >= 2; });
      var best = (state.noTop ? sold.filter(function (P) { return P.f.rubrique.indexOf(state.noTop) >= 0; }) : sold).slice(0, 8);
      var promos = DB.products.filter(function (P) { return P.av && P.badge === 'Promo' && best.indexOf(P) < 0; }).sort(function (a, b) { return b.sales - a.sales; }).slice(0, 4);
      var wa = 'https://wa.me/33766919002?text=' + encodeURIComponent('Bonjour, je cherche : ' + q);
      return '<div class="ccs-nr">' +
        '<div class="ccs-nrhead"><h1>Aucun résultat pour « ' + esc(q) + ' »</h1>' +
        '<p>Ce mot ne correspond à aucun produit du catalogue. Essayez un numéro de nuance, une référence ou un mot plus court :</p>' +
        '<div class="ccs-tips">' + TIPS.map(function (t) { return '<a href="' + esc(resultsUrl(t)) + '">' + esc(t) + '</a>'; }).join('') + '</div></div>' +
        '<div class="ccs-help"><div class="ccs-helptxt"><b>Vous cherchez un produit précis ?</b><span>Dites-nous ce qu\'il vous faut, on vous répond du lundi au vendredi de 9 h à 18 h.</span></div>' +
        '<div class="ccs-helpbtns"><a class="ccs-hbtn" href="tel:+33189701036"><span>Appeler le</span><span>01 89 70 10 36</span></a><a class="ccs-hbtn ccs-hbtn--dark" href="' + esc(wa) + '" target="_blank" rel="noopener">Écrire sur WhatsApp</a></div></div>' +
        '<section class="ccs-sec"><div class="ccs-sechead"><h2>Les plus commandés par les coiffeurs</h2>' +
        (tops.length > 1 ? '<div class="ccs-pills"><button type="button" data-ccs-nt=""' + (state.noTop ? '' : ' class="is-on"') + '>Tout</button>' +
          tops.map(function (t) { return '<button type="button" data-ccs-nt="' + esc(t) + '"' + (state.noTop === t ? ' class="is-on"' : '') + '>' + esc(t) + '</button>'; }).join('') + '</div>' : '') +
        '</div><div class="ccs-grid">' + best.map(productCard).join('') + '</div></section>' +
        (promos.length ? '<section class="ccs-sec ccs-secarts"><div class="ccs-sechead"><h2>En promo en ce moment</h2></div><div class="ccs-grid">' + promos.map(productCard).join('') + '</div></section>' : '') +
        '</div>';
    }
    var moreFacets = {};
    function draw(r) {
      var list = r.products.slice();
      var filtered = list.filter(function (P) { return passes(P); });
      if (state.sort === 'prix-asc') filtered.sort(function (a, b) { return a.price - b.price; });
      else if (state.sort === 'prix-desc') filtered.sort(function (a, b) { return b.price - a.price; });
      else if (state.sort === 'ventes') filtered.sort(function (a, b) { return b.sales - a.sales; });
      var facets = facetData(list).map(function (f) { f.more = moreFacets[f.k]; return f; });
      var visible = facets.slice(0, 5), hidden = facets.slice(5);
      if (state.more) { visible = facets; hidden = []; }
      var nSel = Object.keys(state.sel).reduce(function (a, k) { return a + state.sel[k].length; }, 0);
      var shades = state.gamme ? r.shades.filter(function (s) { return s.gk === state.gamme; }) : r.shades;
      var gammes = {}; r.shades.forEach(function (s) { gammes[s.gk] = gammes[s.gk] || { l: s.gamme, n: 0 }; gammes[s.gk].n++; });
      var total = r.shades.length + filtered.length + r.articles.length + r.formations.length;

      var sortHTML = list.length ? '<label class="ccs-sort"><span>Trier</span><select data-ccs-sort><option value="pertinence">Pertinence</option><option value="ventes">Meilleures ventes</option><option value="prix-asc">Prix croissant</option><option value="prix-desc">Prix décroissant</option></select></label>' : '';
      var h = '<div class="ccs-ptitle"><div class="ccs-prow1"><h1>' + (total ? total + ' résultat' + (total > 1 ? 's' : '') + ' pour « ' + esc(q) + ' »' : 'Aucun résultat pour « ' + esc(q) + ' »') + '</h1>' + sortHTML + '</div>' +
        (r.ignored && r.ignored.length && total ? '<div class="ccs-note">Mot ignoré : ' + esc(r.ignored.join(', ')) + '</div>' : '') +
        (r.partial ? '<div class="ccs-note">Aucun produit ne contient tous vos mots : voici les plus proches.</div>' : '') + '</div>';
      if (!r.total) { el.innerHTML = noResultHTML(); el._r = r; return; }
      if (r.shades.length) {
        var gk = Object.keys(gammes);
        h += '<section class="ccs-sec"><div class="ccs-sechead"><h2>Nuances</h2>' +
          (gk.length > 1 ? '<div class="ccs-pills"><button type="button" data-ccs-g=""' + (state.gamme ? '' : ' class="is-on"') + '>Toutes <span>' + r.shades.length + '</span></button>' +
            gk.map(function (k) { return '<button type="button" data-ccs-g="' + esc(k) + '"' + (state.gamme === k ? ' class="is-on"' : '') + '>' + esc(gammes[k].l) + ' <span>' + gammes[k].n + '</span></button>'; }).join('') + '</div>' : '') + '</div>' +
          '<div class="ccs-shades">' + shades.slice(0, state.allShades ? 999 : 8).map(function (s) { return shadeRow(s); }).join('') + '</div>' +
          (shades.length > 8 && !state.allShades ? '<button type="button" class="ccs-showall" data-ccs-allshades>Voir les ' + shades.length + ' nuances</button>' : '') +
          (r.near.length ? '<div class="ccs-near"><span class="ccs-label">Nuances proches</span><div class="ccs-chips">' + r.near.map(nearChip).join('') + '</div></div>' : '') + '</section>';
      }
      if (list.length) {
        var chips = [];
        Object.keys(state.sel).forEach(function (k) { state.sel[k].forEach(function (v) { chips.push('<button type="button" class="ccs-achip" data-ccs-rm="' + esc(k) + '" data-v="' + esc(v) + '">' + esc(v) + X + '</button>'); }); });
        h += '<section class="ccs-sec ccs-prod"><div class="ccs-sechead"><h2>Produits <span class="ccs-count">' + filtered.length + '</span></h2></div>' +
          '<div class="ccs-layout">' +
          '<aside class="ccs-facets' + (state.sheet ? ' is-open' : '') + '"><div class="ccs-sheethead"><b>Filtres</b><button type="button" data-ccs-sheet aria-label="Fermer">' + X + '</button></div><div class="ccs-fbody">' +
          visible.map(function (f, i) { return facetHTML(f, !desk.matches, i === 0); }).join('') +
          (hidden.length ? '<button type="button" class="ccs-morefacets" data-ccs-morefacets>Plus de filtres (' + hidden.length + ')</button>' : '') + '</div>' +
          '<div class="ccs-sheetfoot"><button type="button" data-ccs-clearall>Effacer</button><button type="button" class="ccs-primary" data-ccs-sheet>Voir les ' + filtered.length + ' produits</button></div></aside>' +
          '<div class="ccs-main"><div class="ccs-toolbar' + (chips.length ? '' : ' ccs-toolbar--empty') + '"><button type="button" class="ccs-fbtn" data-ccs-sheet>Filtrer' + (nSel ? ' (' + nSel + ')' : '') + '</button>' + sortHTML.replace('class="ccs-sort"', 'class="ccs-sort ccs-sort--m"') + '<div class="ccs-achips">' + chips.join('') + (chips.length ? '<button type="button" class="ccs-clear" data-ccs-clearall>Tout effacer</button>' : '') + '</div>' +
          '</div>' +
          (filtered.length ? '<div class="ccs-grid">' + filtered.slice(0, state.limit).map(productCard).join('') + '</div>' : '<div class="ccs-none ccs-none--page"><span>Aucun produit avec ces filtres.</span><button type="button" class="ccs-clear" data-ccs-clearall>Tout effacer</button></div>') +
          (filtered.length > state.limit ? '<button type="button" class="ccs-showall" data-ccs-moreprod>Voir plus de produits</button>' : '') +
          '</div></div></section>';
      }
      if (r.formations.length) {
        h += '<section class="ccs-sec ccs-secarts"><div class="ccs-sechead"><h2>Formations gratuites <span class="ccs-count">' + r.formations.length + '</span></h2>' +
          '<a class="ccs-seclink" href="https://marketing.coiffissimo-professional.fr/formations/">Toutes les formations' + ARROW + '</a></div>' +
          '<div class="ccs-forms">' + r.formations.slice(0, 8).map(formationCard).join('') + '</div></section>';
      }
      if (r.articles.length) {
        h += '<section class="ccs-sec ccs-secarts"><div class="ccs-sechead"><h2>Conseils Coiffissimag <span class="ccs-count">' + r.articles.length + '</span></h2></div><div class="ccs-arts">' + r.articles.slice(0, 8).map(articleCard).join('') + '</div></section>';
      }
      el.innerHTML = h;
      el.querySelectorAll('[data-ccs-sort]').forEach(function (x) { x.value = state.sort; });
      document.documentElement.classList.toggle('ccs-sheet-open', state.sheet && !desk.matches);
      el._r = r;
    }

    el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ccs-f]')) {
        var k = t.dataset.ccsF, arr = state.sel[k] = state.sel[k] || [];
        if (t.checked) { if (arr.indexOf(t.value) < 0) arr.push(t.value); } else state.sel[k] = arr.filter(function (v) { return v !== t.value; });
        state.limit = 24; syncUrl(); draw(el._r);
      } else if (t.matches('[data-ccs-sort]')) { state.sort = t.value; syncUrl(); draw(el._r); }
    });
    el.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-ccs-nt]'))) { state.noTop = t.dataset.ccsNt; draw(el._r); }
      else if ((t = e.target.closest('[data-ccs-g]'))) { state.gamme = t.dataset.ccsG; state.allShades = false; syncUrl(); draw(el._r); }
      else if (e.target.closest('[data-ccs-allshades]')) { state.allShades = true; draw(el._r); }
      else if ((t = e.target.closest('[data-ccs-rm]'))) { state.sel[t.dataset.ccsRm] = (state.sel[t.dataset.ccsRm] || []).filter(function (v) { return v !== t.dataset.v; }); syncUrl(); draw(el._r); }
      else if (e.target.closest('[data-ccs-clearall]')) { state.sel = {}; syncUrl(); draw(el._r); }
      else if (e.target.closest('[data-ccs-morefacets]')) { state.more = true; draw(el._r); }
      else if ((t = e.target.closest('[data-ccs-fmore]'))) { moreFacets[t.dataset.ccsFmore] = true; draw(el._r); }
      else if (e.target.closest('[data-ccs-moreprod]')) { state.limit += 24; draw(el._r); }
      else if (e.target.closest('[data-ccs-sheet]')) { state.sheet = !state.sheet; draw(el._r); }
    });
  }
})();
